export default "__VITE_ASSET__CbMYCfed__"